import { apiClient } from "../../../api/client";

/**
 * Os jobs do Xupinhador são disparados através do dashboard-gestor-backend, e não
 * chamando o Xupinhador direto: as HTTP APIs públicas dele usam JWT authorizer do
 * API Gateway, que só valida assinatura assimétrica (JWKS) — e o token do
 * auth-service é HS256. A rota /gestorXupinhadorPlay valida o JWT em código e
 * repassa a chamada para a API privada do Xupinhador pela VPC.
 */
export const xupinhadorService = {
  gestorPlay: (starters: string[]) =>
    apiClient.post<{ triggered?: string[]; message?: string }>(
      "/gestorXupinhadorPlay",
      { play: "gestor", starters }
    ),
};
